var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ModuleContainer,
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "btn",
            fn: function () {
              return [
                _setup.hasViews
                  ? _c(
                      _setup.MapControlButton,
                      {
                        attrs: {
                          tooltip: _setup.$map.trans("map.identify.title"),
                          active: _setup.show,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.toggleShow()
                          },
                        },
                      },
                      [
                        _c(_setup.SvgIcon, {
                          attrs: {
                            size: "14",
                            type: "mdi",
                            path: _setup.path.icon,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "draggable",
            fn: function (props) {
              return [
                _setup.show
                  ? _c(
                      _setup.DraggablePopup,
                      _vm._b(
                        {
                          attrs: {
                            show: _setup.show,
                            width: 400,
                            height: 300,
                            title: _setup.$map.trans("map.identify.title"),
                          },
                          on: {
                            "update:show": function ($event) {
                              _setup.show = $event
                            },
                            close: _setup.close,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "extra-btn",
                                fn: function () {
                                  return [
                                    _c(
                                      _setup.baseButton,
                                      {
                                        attrs: {
                                          active: _setup.isEventClickActive,
                                          disabled: _setup.isEventClickActive,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _setup.onUseMapClick()
                                          },
                                        },
                                      },
                                      [
                                        _c(_setup.SvgIcon, {
                                          attrs: {
                                            size: "14",
                                            type: "mdi",
                                            path: _setup.path.mapClick,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      _setup.baseButton,
                                      {
                                        attrs: {
                                          active: _setup.isEventClickBox,
                                          disabled: _setup.isEventClickBox,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _setup.onUseBoxSelect()
                                          },
                                        },
                                      },
                                      [
                                        _c(_setup.SvgIcon, {
                                          attrs: {
                                            size: "14",
                                            type: "mdi",
                                            path: _setup.path.boxSelect,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        "DraggablePopup",
                        props,
                        false
                      ),
                      [
                        _c(
                          "div",
                          { staticClass: "identify-control-container" },
                          [
                            _c(
                              "div",
                              { staticClass: "identify-control-header" },
                              [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _setup.$map.trans("map.identify.point")
                                    ) + ":"
                                  ),
                                ]),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(_setup.currentPoint),
                                  },
                                }),
                              ]
                            ),
                            _c("hr", {
                              staticClass: "identify-control-separator",
                            }),
                            _c(
                              "div",
                              { staticClass: "identify-control-body" },
                              _vm._l(_setup.result.items, function (item) {
                                return _c(
                                  "div",
                                  {
                                    key: item.view.id,
                                    staticClass: "identify-control-list-item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "identify-control-list-item__header",
                                      },
                                      [_vm._v(" " + _vm._s(item.name) + " ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "identify-control-list-item__container",
                                      },
                                      _vm._l(item.children, function (child) {
                                        return _c(
                                          "div",
                                          {
                                            key: child.id,
                                            staticClass:
                                              "identify-control-child-item",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                " " + _vm._s(child.name) + " "
                                              ),
                                            ]),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }